<template>
  <div class="gsl-hrm-forgot-password-container">
    <div class="gsl-hrm-forgot-password-wrapper">
      <div class="gsl-hrm-card-container">
        <oxd-text tag="h6" class="gsl-hrm-forgot-password-title">
          {{ $t('auth.reset_password') }}
        </oxd-text>
        <oxd-divider />
        <card-note
          :note-text="$t('auth.reset_password_token_expired_note')"
          class="gsl-hrm-forgot-password-card-note"
          has-note-icon
        />
        <oxd-text class="gsl-hrm-forgot-password-reset">
          <oxd-text
            tag="span"
            class="gsl-hrm-forgot-password-reset--link"
            @click="navigateUrl"
          >
            {{ $t('general.click_here') }}
          </oxd-text>
          {{ $t('auth.request_new_password_token') }}
        </oxd-text>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import CardNote from '../components/CardNote';
import {navigate} from '@/core/util/helper/navigation';
export default {
  name: 'ResetPasswordError',
  components: {
    'card-note': CardNote,
  },
  methods: {
    navigateUrl() {
      navigate('/auth/requestPasswordResetCode');
    },
  },
};
</script>
<style src="./reset-password.scss" lang="scss" scoped></style>
